import React from "react";
import { Tooltip } from "react-tooltip";
import SoratKarshenasi from "./soratkarshenasi/SoratKarshenasi";
import EditSheet from "./EditSheet/EditSheet";
import { FaRegEye, FaSyncAlt, FaCog , FaCheck, FaPen} from "react-icons/fa";
import { useState } from "react";
import {
  getSheetId,
  checkSheet,
  updateSheet,
} from "../../../services/kojaServices";
import Swal from "sweetalert2";
import ClearingModal from "./ClearingModal";
import { downloadUrl } from "../../../confing/confing";
import axios from "axios";
import { toast } from "react-hot-toast";
const RequestTabel = ({ list }) => {
  const [selected, setSelected] = useState({});
  const [selected2, setSelected2] = useState(0);
  const [Open, setOpen] = useState(false);
  const [Checkout, setCheckout] = useState({});
  const [sheetId, setSheetId] = useState();
  const confirmSheet = async (id) => {
    try {
      Swal.fire({
        title: "لطفا منتظر بمانید",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const { data: sheetID } = await getSheetId({
        requestToken: id,
      });
      // console.log(sheetID.result.sheetId)
      setSheetId(sheetID.result.sheetId);
      const { data: check } = await checkSheet(sheetID.result.sheetId);
      console.log(check);
      setCheckout(check.result);
      Swal.close();
      setOpen(true);
    } catch (err) {
      console.log(err.response.data.result_message);
      Swal.fire({
        icon: "error",
        title: `${err.response.data.result_message}`,
        showConfirmButton: true,
        confirmButtonText: "تایید",
      });
    }
  };

  const revisit = async (item) => {
    let token = localStorage.getItem("token");
    try {
      Swal.fire({
        title: "لطفا منتظر بمانید",
        didOpen: () => {
          Swal.showLoading();
        },
      });
    
      let id =  item.expert[0].Ex_Expertors.ExSheetId
      console.log(id)
      const {data }= await axios.get(
        `${downloadUrl}expert/sheet2/${id}`,
        { headers: { authorization: `Bearer ${token}` } }
      );
      console.log(data)
        const link = document.createElement("a");
      link.href = `${downloadUrl}sheet/d/${data.result.fileName}`;
      console.log( `${downloadUrl}sheet/d/${data.result.fileName}`);
      // console.log(item)
      link.download = data.result.fileName;
      link.click();
      Swal.close();
     
    } catch (err) {
      console.log(err);
      Swal.close()
      if(err.response.status ===404 ){
        toast.error('صورت کارشناسی پیدا نشد')
      }
    }
  };

  const Update = async (id) => {
    try {
      Swal.fire({
        title: "لطفا منتظر بمانید",
        didOpen: () => {
          Swal.showLoading();
        },
      });
      const { data: sheetID } = await getSheetId({
        requestToken: id,
      });
      console.log(sheetID.result.sheetId);
      const sheetId = sheetID.result.sheetId;
      Swal.close();
      const senddata = { sheetId: sheetId };
      const { data } = await updateSheet(senddata);
      toast.success('درخواست با موفقیت ارسال شد')
      console.log(data);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div
      className="table-responsive p-0"
      style={{ border: "1px solid #fff", borderRadius: "20px" }}
    >
      <table
        className="table table-bordered text-center"
        style={{ borderRadius: "20px" }}
      >
        <thead>
          <tr style={{ color: "#000" }}>
            <th scope="col" style={{ maxWidth: "140px" }}>
              {" "}
              شماره صورت{" "}
            </th>
            <th scope="col">مالک</th>
            <th scope="col">شماره تماس</th>
            <th scope="col">نوع ملک</th>
            <th scope="col">آدرس</th>
            <th scope="col">تاریخ و ساعت</th>
            <th scope="col">وضعیت</th>
            <th scope="col">عملگر</th>
          </tr>
        </thead>
        <tbody>
          {list && list.map((i, index) => (
            <tr key={index} style={{ color: "#000" }}>
              <th scope="col" style={{ maxWidth: "140px" }}>
                {i.requestToken}
              </th>
              <th scope="col">{i.Ex_Owner?.name}</th>
              <th scope="col">{i.Ex_Owner?.tel}</th>
              <th scope="col">{i.Ex_Category.name}</th>
              <th scope="col" id={`my-anchor-element${index}`}>
                {i.address?.substring(0, 10)}
                <Tooltip
                  anchorSelect={`#my-anchor-element${index}`}
                  content={i.address}
                />
              </th>
              <th scope="col">{i.expert[0]?.Ex_Expertors?.faDateTime}</th>
              <th scope="col">
                {i.expert[0]?.Ex_Expertors?.status === "WaitingForPay"
                  ? "در انتظار پرداخت"
                  : i.expert[0]?.Ex_Expertors?.status === "Pending"
                  ? <span style={{color:"#fff"}}>در انتظار ثبت</span>
                  : i.expert[0]?.Ex_Expertors?.status === "Finish"
                  ? "ثبت نهایی"
                  : i.expert[0]?.Ex_Expertors?.status === "Reject"
                  ? "رد شده"
                  : i.expert[0]?.Ex_Expertors?.status === "Cancel"
                  ? "لغو شده"
                  : i.expert[0]?.Ex_Expertors?.status === "Approved"
                  ? "در انتظار تایید نهایی"
                  : ""}
              </th>
              <th scope="col">
                <button
                  style={{ color: "#000" }}
                  className="btn"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <FaCog />
                </button>
                <ul className="dropdown-menu" style={{ textAlign: "right" }}>
                  {i.expert[0]?.Ex_Expertors?.status === "WaitingForPay" ? (
                    <button
                        className="btn p-0"
                        onClick={() => {
                          confirmSheet(i.requestToken);
                        }}
                      >
                     
                      تغییر نحوه پرداخت
                      </button>
                  ) : i.expert[0]?.Ex_Expertors?.status === "Pending" ? (
                    <button
                      className="btn "
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                      onClick={() => {
                        setSelected(i);
                        setSelected2(1)
                      }}
                    >
                      ثبت صورت
                    </button>
                  ) : i.expert[0]?.Ex_Expertors?.status === "Finish" ? (
                    <div className="d-flex flex-column align-items-start p-1">
                      <button
                        className="btn p-0"
                        onClick={() => {
                          revisit(i);
                        }}
                      >
                      <FaRegEye /> &nbsp;&nbsp;
                      مشاهده
                      </button>

                      <button
                        className="btn p-0"
                        onClick={() => {
                          Update(i.requestToken);
                        }}
                      >
                      <FaSyncAlt />&nbsp;&nbsp;
                        به روز رسانی
                      </button>
                    </div>
                  ) : i.expert[0]?.Ex_Expertors?.status === "Reject" ? (
                    <p className="p-1"> رد شده</p>
                  ) : i.expert[0]?.Ex_Expertors?.status === "Cancel" ? (
                    <p className="p-1">لغو شده</p>
                  ) : i.expert[0]?.Ex_Expertors?.status === "Approved" ? (
                    <div className="d-flex flex-column align-items-start p-1">
                      <button
                        className="btn p-0"
                        onClick={() => {
                          revisit(i);
                        }}
                      >
                      <FaRegEye /> &nbsp;&nbsp;
                        مشاهده
                      </button>
                      <button
                        className="btn p-0"
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal2"
                        onClick={() => {
                          setSelected(i);
                          setSelected2(2)
                        }}
                      >
                      <FaPen/> &nbsp;&nbsp;
                        ویرایش
                      </button>
                      <button
                        className="btn p-0"
                        onClick={() => {
                          confirmSheet(i.requestToken);
                        }}
                      >
                      <FaCheck/> &nbsp;&nbsp;
                        تایید
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </ul>
              </th>
            </tr>
          ))}
        </tbody>
      </table>
    
      <SoratKarshenasi item={selected} type={selected2} setSelected={setSelected} />
      <EditSheet item={selected} type={selected2} setSelected={setSelected} />
      {Open && (
        <ClearingModal
          Open={Open}
          setOpen={setOpen}
          Checkout={Checkout}
          sheetId={sheetId}
        />
      )}
    </div>
  );
};

export default RequestTabel;
